import React, { useEffect, useState } from "react"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

// Import Editor
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"
import PropTypes from "prop-types"
import usePermission from "helpers/permission/usePermission"
import FormInputDate from "../../components/Common/form-input-date"
import FormInputText from "../../components/Common/form-input-text"
import { format } from "date-fns"
import { withTranslation } from "react-i18next"


const RelatoriosAgendadosModal = props => {
  const { relatorioAgendado, isOpen, toggle, saveRelatorioAgendado } = props
  const [editTarefa, setEditTarefa] = useState({ id: null, tipo: 1, hora: null })
  const [startDate, setStartDate] = useState(new Date())

  const usePermissionEdit = usePermission('relatoriosAgendados_editar')

  useEffect(() => {
    if (relatorioAgendado.hora) {
      const [hours, minutes, seconds] = relatorioAgendado.hora.split(':');
      startDate.setHours(Number(hours), Number(minutes), 0, 0)
    }
    setEditTarefa(relatorioAgendado)
  }, [relatorioAgendado])

  const save = () => {
    editTarefa.hora = format(startDate, 'HH:mm')
    saveRelatorioAgendado(editTarefa)
  }

  const describeTipo = tipo => {
    if (tipo === null) {
      return "N/D"
    } else {
      return props.t(`company-report.tipo.${tipo}`)
    }
  }

  return (
    <React.Fragment>
      {editTarefa && (
        <Modal
          isOpen={isOpen}
          role="dialog"
          autoFocus={true}
          centered={true}
          tabIndex="-1"
          scrollable={false}
          size="xl"
          toggle={toggle}>
          <div className="modal-content">
            <ModalHeader toggle={toggle}>{props.t("menu.label.scheduled-reports")}</ModalHeader>
            <ModalBody>
              <form>
                <div className="outer">
                  <div className="outer">

                    <FormInputText
                      attribute="tipo"
                      description="Tipo"
                      value={describeTipo(editTarefa.tipo)}
                      readonly={true}
                      disabled={true}
                      required={true}
                    />
                    <FormInputDate
                      attribute="hora"
                      description={"Hora"}
                      value={startDate}
                      setValue={(e) => setStartDate(e)}
                      dateFormat={"HH:mm"}
                      withHour={true}
                      showTimeSelectOnly={true}
                    />


                  </div>
                </div>
              </form>
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary" disabled={!editTarefa.hora || !usePermissionEdit}
                      onClick={e => save()}>
                {props.t("company-report.modal.save")}
              </Button>
              <Button type="button" color="secondary" className="me-2" onClick={toggle}>
                {props.t("company-report.modal.close")}
              </Button>
            </ModalFooter>
          </div>
        </Modal>
      )}
    </React.Fragment>
  )
}

RelatoriosAgendadosModal.propTypes = {
  toggle: PropTypes.func,
  saveRelatorioAgendado: PropTypes.func,
  isOpen: PropTypes.bool,
  relatorioAgendado: PropTypes.object
}

export default withTranslation()(RelatoriosAgendadosModal)
